import { render } from "./ForumView.vue?vue&type=template&id=935ea7bc&scoped=true"
import script from "./ForumView.vue?vue&type=script&lang=js"
export * from "./ForumView.vue?vue&type=script&lang=js"

import "./ForumView.vue?vue&type=style&index=0&id=935ea7bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935ea7bc"]])

export default __exports__